import { useTriviaContext } from "../context-trivia";
import { getContainerScaledSize } from "../trivia-layout";
import { formatTriviaScore } from "../trivia-score";

export function TriviaResultChart() {
  const { config, score, containerSize } = useTriviaContext();

  const size = getContainerScaledSize(containerSize, 0.55, 120);
  const thickness = Math.round(size * 0.09);
  const scoreText = formatTriviaScore(score, config.results.scoreFormat);

  return (
    <div className="flex h-full w-full items-center justify-center">
      <div
        className="relative rounded-full"
        style={{
          width: size,
          height: size,
          background: `conic-gradient(${config.theme.correctColor} 0% ${score.percentage}%, ${config.theme.incorrectColor} ${score.percentage}% 100%)`,
        }}
      >
        <div
          className="absolute flex items-center justify-center rounded-full"
          style={{
            inset: thickness,
            backgroundColor: config.theme.primaryBackground,
          }}
        >
          {!!scoreText && (
            <span
              className="font-bold"
              style={{
                fontSize: "var(--trivia-text-display)",
                color: config.theme.primaryText,
              }}
            >
              {scoreText}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
